import { BaseEntity } from '../../models/models';

export const defaultDoc: BaseEntity = {
  dateModified: '1900-01-01T01:01:01.1234567-06:00',
};

export const getValueFromLocalStorage = (value: string) => {
  return localStorage.getItem(value) + '';
};

export default defaultDoc;
